var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseSpan',[_vm._v("© "+_vm._s(_vm.year)+" FOCUS, Kalkhoff & Urban Arrow")])
}
var staticRenderFns = []

export { render, staticRenderFns }